import classNames from "classnames";

import styles from "./spinner.module.css";

type SpinnerProps = {
  height?: number;
  width?: number;
  colour?: "cerise" | "white" | "navy";
};

/**
 * TODO: Check with design team about spinner
 * TODO: Replace all spinners with this spinner
 */
export default function Spinner({
  height = 24,
  width = 24,
  colour = "white",
}: SpinnerProps) {
  const innerClassNames = classNames(
    "block absolute w-full h-full border-[3px] rounded-[50%] border-[transparent]",
    {
      "border-l-white": colour === "white",
      "border-l-cerise": colour === "cerise",
      "border-l-pro-blue": colour === "navy",
    }
  );

  return (
    <div
      className="flex items-center justify-center"
      data-color={colour}
      role={"progressbar"}
      aria-label={"Loading"}
    >
      <div
        className={classNames(styles.spinner, "relative")}
        style={{ height, width }}
      >
        <div className={innerClassNames}></div>
        <div className={innerClassNames}></div>
        <div className={innerClassNames}></div>
        <div className={innerClassNames}></div>
      </div>
    </div>
  );
}
